import React from 'react';
import { pagePreviews } from '../../data/pagePreviews';
export function PagePreviews() {
  return <section aria-labelledby="material-title" className="w-full bg-ink-850 pb-16 md:pb-24" data-id="element-141" data-mp="3ia5r6ve3gvee">
      <div className="mx-auto max-w-6xl px-5" data-id="element-142" data-mp="33li134n0pdvu">
        <div className="flex flex-col items-center gap-2 border-t border-ink-border pt-12 text-center" data-id="element-143" data-mp="33kq35n5y742e">
          <h2 id="material-title" className="font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-144" data-mp="38i8bpcg1zh9v">
            Un vistazo al material incluido
          </h2>
          <p className="text-[15px] text-subtle" data-id="element-145" data-mp="2yjk8vkwn38qr">+200 páginas en PDF · Deslizá para ver</p>
        </div>
      </div>

      <ul className="mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 md:mx-auto md:max-w-6xl" data-id="element-146" data-mp="2pl74dkz1152r">
        {pagePreviews.map(page => <li key={page.src} className="w-[68%] shrink-0 snap-start overflow-hidden rounded-2xl border border-ink-border bg-ink-card shadow-panel sm:w-[42%] md:w-[30%] lg:w-[23%]" data-id="element-147" data-mp="ivah15hoc3j3">
            <img src={page.src} alt={page.alt} loading="lazy" className="aspect-[3/4] w-full object-cover object-top" data-id="element-148" data-mp="2y25n573j6ecj" />
          </li>)}
      </ul>
    </section>;
}